import { apiClient } from './apiClient';
import type { ApiResponse } from '@/types/api.types';
import type { NewPatientFormSettings } from '@/pages/leads/newPatientForm/newPatientFormRules';

/**
 * The account's New Patient form settings for staff: resolved available
 * fields (catalog order and per-mode shown/required already applied by the
 * server), the global hint switch, and per-option hints.
 */
export function getNewPatientForm(): Promise<NewPatientFormSettings> {
  return apiClient
    .get<ApiResponse<NewPatientFormSettings>>('/new-patient-form')
    .then((response) => response.data.data);
}
